// @flow
import FilterSelectedList from './FilterSelectedList';

export default FilterSelectedList;
